import React from "react";
import ReactDOM from "react-dom/client";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "./styles/variables.css";
import "./styles/typography.css";
import "./styles/global.css";
import "./styles/animations.css";
import "./styles/responsive.css";
import "./components/common/customCursor.css";
import "./components/common/announcementBar.css";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
